export default __webpack_public_path__ + "43a4967de4ed9cf2c95c74f986decb46.png";